module.exports = __webpack_public_path__ + "static/media/litho_skulls.3093a623.jpg";